import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-phms-brand-mark',
  templateUrl: './phms-brand-mark.component.html',
  styles: [':host { display: block; } svg { display: block; width: 100%; height: 100%; }'],
  host: { role: 'img', 'aria-label': 'PHMS scales of justice logo' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhmsBrandMarkComponent {}
